import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  mode: 'grid', // Supported modes: 'grid', 'table', 'timeline'
  tablePageSize: Number(25),
};

const viewModeSlice = createSlice({
  name: 'viewMode',
  initialState,
  reducers: {
    setViewMode: (state, action) => {
      state.mode = action.payload;
    },
    setTablePageSize: (state, action) => {
      state.tablePageSize = Number(action.payload);
    },
  },
});

export const { setViewMode, setTablePageSize } = viewModeSlice.actions;
export default viewModeSlice.reducer;
